const messages = {
  "Distributor": ["Distribuidor", "Distribuïdor"],
  "Could not identify the supplier. Try again.": ["No se ha podido identificar el proveedor. Reintenta.", "No s'ha pogut identificar el proveïdor. Torna-ho a provar."],
  "Choose the supplier manually before creating the delivery note.": ["Selecciona el proveedor manualmente antes de crear el albarán.", "Selecciona el proveïdor manualment abans de crear l'albarà."],
  "Retry": ["Reintentar", "Torna-ho a provar"],
};

export const ocrDistributorTranslator = (languageId) => {
  const language = String(languageId || "en").split(/[-_]/)[0];
  const index = language === "es" ? 0 : language === "ca" ? 1 : -1;
  return (key, values = {}) => String(index < 0 ? key : messages[key]?.[index] || key)
    .replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
};
